"use strict";

import BetragsrechnerBase from "../betragsrechner.base";

class HonorarkostenOhneQualiRechner extends BetragsrechnerBase {
  /*@ngInject*/
  constructor($scope, kontext) {
    super($scope, kontext);
    this.name = "honorarkosten_ohne_quali";
    this.component_name = "honorarkosten-ohne-quali";
    this.labels = { taetigkeit_bez: "Bezeichnung der Tätigkeit",
                    anzahl_zeiteinheiten: "Anzahl Zeiteinheiten",
                    zeiteinheit: "Zeiteinheit",
                    kosten_pro_zeiteinheit: "Honorarsatz pro Zeiteinheit in Euro",
                    dokument_geschwaerzt: "Bestätigung" };
  }

  get_labelmapping() {
    return this.labels;
  }

  get_fields() {
    return { taetigkeit_bez: "",
             anzahl_zeiteinheiten: "",
             zeiteinheit: "Leere Zeiteinheit",
             kosten_pro_zeiteinheit: "",
             dokument_geschwaerzt: "",
    };
  }
}
export default HonorarkostenOhneQualiRechner;
